"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INITIAL_TICK_WIDTH = exports.CIRCLE_WIDTH = exports.getStepWidth = void 0;
exports.getStepWidth = function (_a) {
    var ref = _a.ref, min = _a.min, max = _a.max, circleWidth = _a.circleWidth;
    if (!ref || !ref.getBoundingClientRect) {
        return 0;
    }
    var width = ref.getBoundingClientRect().width;
    return (width - circleWidth) / (max - min);
};
exports.CIRCLE_WIDTH = 20;
exports.INITIAL_TICK_WIDTH = 4;
//# sourceMappingURL=ApSlider.utils.js.map